import clsx from 'clsx';

import { useState, useEffect } from 'react';
import positionGeolocPikko from '../../../styles/img/logo/position-geolocation-pikko.svg';
import PrimaryButton from '../../button/PrimaryButton';

import { isOlderThanOneHour, isOlderThanFiveMinutes } from '../../../utils/date-helper'

import { PERMISSION_DENIED, PERMISSION_GRANTED } from '../constant'
import { requestGeolocation } from '../utils'
import { GeolocationWrapModal } from './GeolocationWrapModal'

import { useLocalStorage } from '../../../hooks/useLocalStorage';

export const GeolocationVerifModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);

  const [, setIsCheckStore] = useLocalStorage('isCheckStore');
  const [geolocationPermission, setGeolocationPermission] = useLocalStorage('geolocationPermission');
  const [geolocationPositionResult, setGeolocationPositionResult] = useLocalStorage('geolocationPositionResult');
  const [geolocationPermissionLastDemand, setGeolocationPermissionLastDemand] =
    useLocalStorage('geolocationPermissionLastDemand');

  const geolocationPermissionLastDemandDate = JSON.parse(geolocationPermissionLastDemand)

  function closeAndShowCheckStore () {
    setIsCheckStore('true');
    setIsOpen(false);
  }

  const handleClose = () => {
    setGeolocationPermissionLastDemand(JSON.stringify(new Date()));
    closeAndShowCheckStore()
  }

  function managePositionResult (resultGeolocation) {
    if (resultGeolocation.status === 'success') {
      setGeolocationPermission(resultGeolocation.code);
      setGeolocationPositionResult(JSON.stringify(resultGeolocation));

      setIsOpen(false);
    }
    else {
      setError("Une erreur inconnue s'est produite");
      closeAndShowCheckStore()
    }
  }

  const checkPermission = async () => {
    try {
      let resultGeolocation

      if (geolocationPermission === PERMISSION_GRANTED &&
          geolocationPositionResult &&
          !isOlderThanFiveMinutes(geolocationPermissionLastDemandDate)) {
        resultGeolocation = JSON.parse(geolocationPositionResult)
      }
      else {
        resultGeolocation = await requestGeolocation();
      }
      console.log('checkPermission', resultGeolocation)
      managePositionResult(resultGeolocation)
      setGeolocationPermissionLastDemand(JSON.stringify(new Date()));
    } catch (error) {
      console.error('checkPermission', error)

      setGeolocationPermission(error.code);
      setGeolocationPermissionLastDemand(JSON.stringify(new Date()));
      setError(error.message)
    } finally {
      setTimeout(() => {
        setIsOpen(false)
      }, 3000);
    }
  };

  useEffect(() => {
    function checkLocalGeolocation () {
      console.log('checkLocalGeolocation', geolocationPermission)
      console.log('checkLocalGeolocation', geolocationPermissionLastDemandDate)

      if (geolocationPermission === PERMISSION_DENIED ||
          geolocationPermission === PERMISSION_GRANTED ||
          (geolocationPermissionLastDemandDate && !isOlderThanOneHour(geolocationPermissionLastDemandDate))
        ) {
        setIsOpen(false);
      }
      else {
        setIsCheckStore(null);
        setIsOpen(true)
      }
    }

    checkLocalGeolocation()
  }, [geolocationPermission, geolocationPermissionLastDemandDate]);

  return (
    <GeolocationWrapModal image={positionGeolocPikko} isOpen={isOpen}>
      <h1 className="text-3xl font-bold text-center mb-2">
        Besoin de ta position 📍
      </h1>

      <p className={clsx("text-base text-center mb-6",
        {
          "text-gray-500": !error,
          "text-red-500": error
        }
      )}>
        {error || "C’est pour que tu ne te trompes pas de magasin !"}
      </p>

      <div className="flex flex-col gap-4 justify-center items-center w-full">
        <PrimaryButton
          label="D'accord"
          onClick={error ? handleClose : checkPermission}
          className="w-full"
        />

        {!error &&
          <button type="button" className="text-gray-500 border-b border-gray-500 mt-4 cursor-pointer"
                style={{ borderBottomStyle: "solid" }}
                onClick={handleClose}>
          Plus tard !
        </button>}
      </div>
    </GeolocationWrapModal>
  );
};
